import Typography from "../Typography";

export default function CheckBoxRadio({ label, disabled = false, value = 0, checked = false, group, onChange }) {
    return (
        <label className="justify-start items-center gap-2 inline-flex">
            <input type="radio" className="peer sr-only" name={group} disabled={disabled} value={value} checked={checked} onChange={onChange}/>

            <div className="w-4 h-4 rounded-full flex items-center justify-between cursor-pointer
            bg-white  border border-gray-400 hover:border-primary-medium  text-sm group peer-checked:border-primary-medium peer-checked:border-[0.375em]">
            </div>
            <Typography component={"body1-semibold"}>{label}</Typography>
        </label>
    )
}
